import type { NextPage } from 'next'
import Link from 'next/link'
import Image from 'next/image'
import LogoImage from '../assets/logo-gg-ke.png'


interface IProps {
}

const Component: NextPage<IProps> = () => {

  return (
    <div className='h-[100px] flex justify-center'>
      <div className='flex w-[1200px] max-w-[1200px] items-center'>
        <div className='w-[193px]'>
          <Link href="/">
            <a>
              <h1 className='sr-only'>{process.env.NEXT_PUBLIC_SERVICE_NAME}</h1>
              <Image src={LogoImage} layout="intrinsic" alt="경기도 환경영향평가 로고" />
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Component
